import React from 'react';
import { Play } from 'lucide-react';

const videos = [
  {
    id: 1,
    src: "https://www.facebook.com/plugins/video.php?height=476&href=https%3A%2F%2Fwww.facebook.com%2Freel%2F1265086292203944%2F&show_text=false&width=267&t=0",
    title: "Empire Lawn Care in Action",
    width: 267,
    height: 476,
    type: "portrait"
  },
  {
    id: 2,
    src: "https://www.facebook.com/plugins/video.php?height=476&href=https%3A%2F%2Fwww.facebook.com%2F100087080497238%2Fvideos%2F958087852834363%2F&show_text=false&width=267&t=0",
    title: "Our Work",
    width: 267,
    height: 476,
    type: "portrait"
  },
  {
    id: 3,
    src: "https://www.facebook.com/plugins/video.php?height=314&href=https%3A%2F%2Fwww.facebook.com%2F100087080497238%2Fvideos%2F1840131396471605%2F&show_text=false&width=560&t=0",
    title: "Lawn Transformation",
    width: 560,
    height: 314,
    type: "landscape"
  }
];

export default function VideoShowcase() {
  return (
    <section id="videos" className="py-20 bg-slate-50" data-testid="video-showcase-section">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-12">
          <div className="inline-flex items-center bg-green-900/10 rounded-full px-4 py-2 mb-4">
            <Play className="text-green-900 mr-2" size={20} />
            <span className="text-green-900 font-inter text-sm font-medium">
              See Us In Action
            </span>
          </div>
          <h2 className="font-oswald text-3xl sm:text-4xl font-bold text-green-900 mb-4">
            Our Work
          </h2>
          <div className="gold-accent-line w-24 mx-auto mb-6" />
          <p className="font-inter text-gray-600 max-w-2xl mx-auto">
            Watch our team deliver professional results for properties across Coffs Harbour.
          </p>
        </div>

        {/* Videos Grid */}
        <div className="flex flex-col items-center gap-8">
          {/* Portrait Videos Row */}
          <div className="flex flex-wrap justify-center gap-8">
            {videos.filter(v => v.type === "portrait").map((video) => (
              <div 
                key={video.id}
                className="bg-white rounded-2xl shadow-lg overflow-hidden p-4"
                data-testid={`video-${video.id}`}
              >
                <iframe
                  src={video.src}
                  width={video.width}
                  height={video.height}
                  style={{ border: 'none', overflow: 'hidden', borderRadius: '12px' }}
                  scrolling="no"
                  frameBorder="0"
                  allowFullScreen={true}
                  allow="autoplay; clipboard-write; encrypted-media; picture-in-picture; web-share"
                  title={video.title}
                />
              </div>
            ))}
          </div>
          
          {/* Landscape Videos Row */}
          <div className="flex flex-wrap justify-center gap-8">
            {videos.filter(v => v.type === "landscape").map((video) => (
              <div 
                key={video.id}
                className="bg-white rounded-2xl shadow-lg overflow-hidden p-4"
                data-testid={`video-${video.id}`}
              >
                <iframe
                  src={video.src}
                  width={video.width}
                  height={video.height}
                  style={{ border: 'none', overflow: 'hidden', borderRadius: '12px' }}
                  scrolling="no"
                  frameBorder="0"
                  allowFullScreen={true}
                  allow="autoplay; clipboard-write; encrypted-media; picture-in-picture; web-share"
                  title={video.title}
                />
              </div>
            ))}
          </div>
        </div>

        {/* Follow Us CTA */}
        <div className="mt-12 text-center">
          <a
            href="https://www.facebook.com/profile.php?id=100087080497238"
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center gap-2 bg-green-900 hover:bg-green-800 text-white font-oswald font-medium px-6 py-3 rounded-lg transition-colors btn-empire"
            data-testid="follow-facebook-btn"
          >
            <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24">
              <path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z"/>
            </svg>
            Follow Us on Facebook
          </a>
        </div>
      </div>
    </section>
  );
}
